import { useState } from 'react'

const BANDERAS = ['🇨🇴','🇨🇦','🇺🇸','🇧🇷','🇯🇵','🇨🇳','🇬🇧','🇫🇷','🇵🇹']

const PLANES = [
  {
    id: 'trial',
    badge: null,
    emoji: '🎁',
    nombre: '3-Day Free Trial',
    precio: 'FREE',
    subprecio: '3 days full access',
    color: '#22C55E',
    descripcion: 'Full platform access for 3 days',
    beneficios: [
      'Access to interactive games',
      'Access to A1-A2 lessons',
      'AI pronunciation tools',
      'Vocabulary and grammar activities',
      'Progress tracking system',
      '1 live class (group or private)',
    ]
  },
  {
    id: 'monthly',
    badge: null,
    emoji: '📅',
    nombre: 'EspañolGo Plus',
    precio: '$119.99',
    subprecio: 'USD / month',
    color: '#3B82F6',
    descripcion: 'Perfect to start your Spanish journey',
    beneficios: [
      'Full access to A1-B1 content',
      '4 live group classes per month (1/week)',
      '2 private 1-to-1 classes per month',
      'Daily challenges and EduNova games',
      'Community VideoForums access',
      'Progress tracking dashboard',
      'Achievement badges and ranking',
      'AI pronunciation tools',
      'Vocabulary and grammar activities',
    ]
  },
  {
    id: 'eightmonths',
    badge: 'BEST VALUE',
    emoji: '💎',
    nombre: 'EspañolGo Advanced',
    precio: '$719.99',
    subprecio: 'USD / 7 months (~$102.86/mo)',
    color: '#F59E0B',
    descripcion: 'The complete Spanish learning experience',
    beneficios: [
      'Full access to A1-C1 content',
      '8 live group classes per month (2/week)',
      '4 private 1-to-1 classes per month',
      'Everything included in Plus plan',
      'Premium speaking clubs and conversation sessions',
      'Detailed pronunciation feedback by teacher',
      'Teacher writing correction',
      'Priority class access',
      'Advanced progress analytics',
    ]
  },
  {
    id: 'annual',
    badge: '👑 VIP',
    emoji: '👑',
    nombre: 'EspañolGo Mastery',
    precio: '$1,199',
    subprecio: 'USD / year (~$99.92/mo)',
    color: '#EF4444',
    descripcion: 'The ultimate VIP Spanish mastery experience',
    beneficios: [
      'Everything included in Plus and Advanced',
      '16 live group classes per month (4/week)',
      '8 private 1-to-1 classes per month',
      'Official EspañolGo Spanish course certificate',
      'Personal academic mentor',
      'Possible in-person meetup in Latin America with flight discount',
      'Personalized monthly evaluations',
      'Early access to AI features',
      'Priority support system',
      'Verified VIP digital achievement badge',
    ]
  }
]

function ModalPlan({ plan, onCerrar, onElegir }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
      onClick={onCerrar}>
      <div style={{ background:'#fff', borderRadius:20, maxWidth:520, width:'100%', maxHeight:'90vh', overflowY:'auto', position:'relative' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ background:'linear-gradient(135deg,' + plan.color + 'dd,' + plan.color + ')', borderRadius:'20px 20px 0 0', padding:28, color:'#fff', position:'relative' }}>
          {plan.badge && (
            <div style={{ position:'absolute', top:16, right:16, background:'rgba(255,255,255,0.25)', borderRadius:999, padding:'4px 12px', fontSize:12, fontWeight:800 }}>
              {plan.badge}
            </div>
          )}
          <div style={{ fontSize:48, marginBottom:8 }}>{plan.emoji}</div>
          <h2 style={{ fontSize:24, fontWeight:900, marginBottom:4 }}>{plan.nombre}</h2>
          <p style={{ fontSize:14, opacity:.85, marginBottom:16 }}>{plan.descripcion}</p>
          <div style={{ display:'flex', alignItems:'baseline', gap:8 }}>
            <span style={{ fontSize:40, fontWeight:900 }}>{plan.precio}</span>
            <span style={{ fontSize:14, opacity:.8 }}>{plan.subprecio}</span>
          </div>
        </div>
        <div style={{ padding:28 }}>
          <h3 style={{ fontSize:15, fontWeight:800, color:'#1A1A2E', marginBottom:16 }}>What is included:</h3>
          <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:24 }}>
            {plan.beneficios.map((b, i) => (
              <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                <span style={{ color: plan.color, fontSize:14, flexShrink:0, marginTop:1, fontWeight:800 }}>✓</span>
                <span style={{ fontSize:14, color:'#374151', lineHeight:1.5 }}>{b}</span>
              </div>
            ))}
          </div>
          {(plan.id === 'annual') && (
            <div style={{ background:'#FEF9EC', border:'1px solid #F59E0B', borderRadius:10, padding:'10px 14px', marginBottom:16, fontSize:12, color:'#92400E', lineHeight:1.6 }}>
              ⚠️ The in-person meetup is subject to availability, location and minimum group requirements. Details will be communicated through the platform.
            </div>
          )}
          <button onClick={() => onElegir(plan)}
            style={{ width:'100%', padding:'14px', background: plan.color, color:'#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:16, fontWeight:800, cursor:'pointer', marginBottom:10 }}>
            {plan.id === 'trial' ? 'Start Free Trial' : 'Get ' + plan.nombre}
          </button>
          <button onClick={onCerrar}
            style={{ width:'100%', padding:'12px', background:'#F4F6FA', color:'#6B7280', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  )
}

export default function Precios({ onContinuar }) {
  const [planSeleccionado, setPlanSeleccionado] = useState(null)

  const letras = [
    { l:'E', c1:'#FFE566', c2:'#FFD700' },
    { l:'s', c1:'#FFE566', c2:'#FFD700' },
    { l:'p', c1:'#FFE566', c2:'#FFD700' },
    { l:'a', c1:'#FFE566', c2:'#FFD700' },
    { l:'ñ', c1:'#7BA7E8', c2:'#4A7FD4' },
    { l:'o', c1:'#7BA7E8', c2:'#4A7FD4' },
    { l:'l', c1:'#7BA7E8', c2:'#4A7FD4' },
    { l:'G', c1:'#FF8A8A', c2:'#E84545' },
    { l:'o', c1:'#FF8A8A', c2:'#E84545' },
  ]

  function handleElegir(plan) {
    setPlanSeleccionado(null)
    onContinuar(plan)
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', position:'relative', overflow:'hidden', fontFamily:'system-ui, sans-serif' }}>

      <div style={{ position:'absolute', inset:0, background:'linear-gradient(145deg, #0a1628 0%, #0f2347 40%, #1a1248 70%, #0d1f3c 100%)', zIndex:0 }} />

      <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', zIndex:1, opacity:0.12 }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="geo2" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
            <polygon points="30,2 58,16 58,44 30,58 2,44 2,16" fill="none" stroke="#FFD700" strokeWidth="0.8"/>
            <polygon points="30,12 48,21 48,39 30,48 12,39 12,21" fill="none" stroke="#4A90D9" strokeWidth="0.5"/>
            <circle cx="30" cy="30" r="2" fill="#FFD700" opacity="0.6"/>
          </pattern>
          <pattern id="dots2" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
            <circle cx="15" cy="15" r="1" fill="#ffffff" opacity="0.4"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dots2)"/>
        <rect width="100%" height="100%" fill="url(#geo2)"/>
      </svg>

      <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', zIndex:2, opacity:0.15 }} xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="10%" cy="15%" rx="200" ry="200" fill="#FFD700" opacity="0.12"/>
        <ellipse cx="90%" cy="85%" rx="250" ry="250" fill="#009C3B" opacity="0.1"/>
        <ellipse cx="50%" cy="5%"  rx="160" ry="160" fill="#CE1126" opacity="0.08"/>
      </svg>

      <div style={{ position:'absolute', inset:0, background:'rgba(10,22,40,0.4)', zIndex:3 }} />

      <button onClick={() => onContinuar({ id:'back', esBack:true })}
        style={{ position:'fixed', top:20, left:20, zIndex:100, background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.3)', borderRadius:10, padding:'8px 16px', color:'#fff', fontFamily:'inherit', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}>
        ← Back
      </button>

      <div style={{ position:'relative', zIndex:4, width:'100%', display:'flex', flexDirection:'column', alignItems:'center', padding:'40px 20px', minHeight:'100vh' }}>

        <div style={{ marginBottom:8, display:'flex', alignItems:'center', gap:8 }}>
          {BANDERAS.map((f,i) => <span key={i} style={{ fontSize:'16px' }}>{f}</span>)}
        </div>

        <div style={{ display:'flex', alignItems:'baseline', marginBottom:8 }}>
          {letras.map((lt, i) => (
            <svg key={i} width="30" height="52" viewBox="0 0 36 62" style={{ overflow:'visible', flexShrink:0, marginRight: i===6 ? '3px' : '-1px' }}>
              <defs>
                <linearGradient id={'wvp' + i} x1="0%" y1="110%" x2="0%" y2="-10%">
                  <stop offset="0%" stopColor={lt.c2} />
                  <stop offset="45%" stopColor={lt.c1} />
                  <stop offset="100%" stopColor="#ffffff" stopOpacity="0.2" />
                </linearGradient>
                <clipPath id={'cpp' + i}>
                  <text x="1" y="52" fontSize="52" fontWeight="900" fontFamily="system-ui, sans-serif">{lt.l}</text>
                </clipPath>
              </defs>
              <rect x="-4" y="-4" width="44" height="70" fill={'url(#wvp' + i + ')'} clipPath={'url(#cpp' + i + ')'} />
            </svg>
          ))}
        </div>

        <p style={{ color:'rgba(255,255,255,0.75)', fontSize:15, marginBottom:40, textAlign:'center' }}>
          Choose your plan and start speaking Spanish today
        </p>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(240px, 1fr))', gap:14, maxWidth:1100, width:'100%', marginBottom:40 }}>
          {PLANES.map(plan => (
            <div key={plan.id} onClick={() => setPlanSeleccionado(plan)}
              style={{ background: plan.badge ? 'linear-gradient(160deg,' + plan.color + '22,' + plan.color + '11)' : 'rgba(255,255,255,0.06)',
                border:'1.5px solid ' + (plan.badge ? plan.color : 'rgba(255,255,255,0.15)'),
                borderRadius:16, padding:20, cursor:'pointer', transition:'all .2s ease', position:'relative',
                backdropFilter:'blur(10px)', marginTop: plan.badge ? 16 : 0 }}
              onMouseOver={e => { e.currentTarget.style.transform='translateY(-6px)'; e.currentTarget.style.border='1.5px solid ' + plan.color }}
              onMouseOut={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.border='1.5px solid ' + (plan.badge ? plan.color : 'rgba(255,255,255,0.15)') }}>

              {plan.badge && (
                <div style={{ position:'absolute', top:-14, left:'50%', transform:'translateX(-50%)', background: plan.color, color:'#fff', borderRadius:999, padding:'3px 12px', fontSize:10, fontWeight:800, whiteSpace:'nowrap' }}>
                  {plan.badge}
                </div>
              )}

              <div style={{ fontSize:32, marginBottom:10, textAlign:'center' }}>{plan.emoji}</div>
              <div style={{ fontSize:13, fontWeight:800, color:'#fff', textAlign:'center', marginBottom:6, lineHeight:1.3 }}>{plan.nombre}</div>
              <div style={{ fontSize:22, fontWeight:900, color: plan.color, textAlign:'center', marginBottom:2 }}>{plan.precio}</div>
              <div style={{ fontSize:10, color:'rgba(255,255,255,0.6)', textAlign:'center', marginBottom:14 }}>{plan.subprecio}</div>

              <div style={{ display:'flex', flexDirection:'column', gap:5, marginBottom:16 }}>
                {plan.beneficios.slice(0,4).map((b,i) => (
                  <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:6 }}>
                    <span style={{ color: plan.color, fontSize:11, flexShrink:0, fontWeight:800 }}>✓</span>
                    <span style={{ fontSize:10, color:'rgba(255,255,255,0.75)', lineHeight:1.4 }}>{b}</span>
                  </div>
                ))}
                {plan.beneficios.length > 4 && (
                  <div style={{ fontSize:10, color:'rgba(255,255,255,0.5)', textAlign:'center', marginTop:2 }}>
                    +{plan.beneficios.length - 4} more benefits
                  </div>
                )}
              </div>

              <button style={{ width:'100%', padding:'9px', background: plan.color, color:'#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:700, cursor:'pointer' }}>
                {plan.id === 'trial' ? 'Start Free' : 'Choose Plan'}
              </button>
            </div>
          ))}
        </div>

        <p style={{ color:'rgba(255,255,255,0.5)', fontSize:12, textAlign:'center', marginBottom:16 }}>
          No credit card required for free trial · Cancel anytime · Secure payments
        </p>

        <button onClick={() => onContinuar({ id:'existing', nombre:'Existing Plan', precio:'', emoji:'✅', esLogin:true })}
          style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', fontSize:14, cursor:'pointer', fontFamily:'inherit', textDecoration:'underline', marginBottom:20 }}>
          Already have a plan? Click here to sign in
        </button>

      </div>

      {planSeleccionado && (
        <ModalPlan
          plan={planSeleccionado}
          onCerrar={() => setPlanSeleccionado(null)}
          onElegir={handleElegir}
        />
      )}
    </div>
  )
}
